module.exports = __webpack_public_path__ + "static/media/phones.168a77e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/kudos/phones.png
// module id = 37
// module chunks = 0